import { createApiCallActions } from '../../../common/store/generic.actions';
import { FileModel } from './types';

export const exportActions = {
  exportToCsv: createApiCallActions<FileModel>('exportToCsv', 'exportToCsv'),
};

export type ExportAction = typeof exportActions;
